export const pushState = (state) => ({
  type: 'PUSH_STATE',
  state: state
});

export const waitClient = (onClient) => ({
  type: 'WAIT_CLIENT',
  onClient: onClient,
});

export const setClient = (client) => ({
  type: 'SET_CLIENT',
  client: client,
});



// WEBPACK FOOTER //
// ./src/actions/PushAction.js